import React from "react";
import { useLocalization } from "../../../context/LocalizationContext";
import { useWebSocket } from "../../../context/WebSocketContext";
import "./LanguageToggle.css";

const LanguageToggle = () => {
  const { language, toggleLanguage, t } = useLocalization();
  const { sendMessage } = useWebSocket();

  const handleLanguageChange = (newLanguage) => {
    if (language !== newLanguage) {
      toggleLanguage();
      // Send language_selected event to WebSocket
      sendMessage("language_selected", { language: newLanguage });
    }
  };

  return (
    <div className="language-toggle">
      <button
        className={`lang-btn ${language === "en" ? "active" : ""}`}
        onClick={() => handleLanguageChange("en")}
        aria-label={t("language.english")}
      >
        English
      </button>
      <button
        className={`lang-btn ${language === "ar" ? "active" : ""}`}
        onClick={() => handleLanguageChange("ar")}
        aria-label={t("language.arabic")}
      >
        العربية
      </button>
    </div>
  );
};

export default LanguageToggle;
